package com.iregained.eventapp.pages

import androidx.compose.runtime.Composable
import com.iregained.eventapp.components.layouts.PageLayoutData
import com.iregained.eventapp.components.sections.event_details.sections.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout

@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Home - Event Portal"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        EventHeroSection()
        EventSocialProofSection()
        ClinicalApplicationsSection()
        PatientsRecoveryProtocolsSection()
        CliniciansWorkflowSection()
        EventRegistrationSection()
    }
}